const wait = (delay, ...args) => new Promise(resolve => setTimeout(resolve, delay, ...args));

const PromiseUtils = {
  wait
}

export default PromiseUtils;
